import React from 'react'
import { Form } from 'semantic-ui-react'

export default class OnlineField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const packageOptions = [
      { key: 1, text: 'Small', value: 'small' },
      { key: 2, text: 'Medium', value: 'medium' },
      { key: 3, text: 'Large', value: 'large' },
    ]

    return (
      <Form.Select
        required
        fluid
        label="Package Size"
        options={packageOptions}
        placeholder="Small/Medium/Large"
        onChange={(e, data) => onChange('package_size', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/packageField.js